<template>
  <div id="planForBirth">
    <div class="Grid6DF38708" :style="backImg">
      <div class="returnBtn">
        <md-icon name="arrow-left" size="lg"  @click="goBack" />
      </div>
      <div class="GridA80946D5">
<!--        <img-->
<!--          :src="backImg2"-->
<!--          class="text5631D312"-->
<!--        />-->
        <span :text="'文本内容'" class="text5631D312">{{$t('label.label28')}}</span>
        <!--        <span :text="'文本内容'" class="text5631D313">餘額自動轉入 讓您輕鬆享收益</span>-->
      </div>
      <div class="GridF930D8ED">
        <div class="textImageD034D1AF">
          <img
            :src="backImg1"
            class="img70009100"
          />
          <p :text="'文本内容'" class="text5A37A290">
            <span class="span1">{{$t('label.label29')}}</span>
            <span class="span2">{{$t('label.label30')}}</span>
          </p>
        </div>
      </div>
      <div class="GridD2371EF7">
        <md-button :text="'按钮'" :type="'primary'" :round="true" @click="toListPage">{{$t('label.label15')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Dialog, Icon } from '@gidc/mobile'
import backImg from '../../assets/images/planForBirth.png'
import backImg1 from '../../assets/images/planForBirth_a.png'
import backImg2 from '../../assets/images/planForBirth_font.png'
import { mapGetters } from 'vuex'
export default {
  name: 'planForBirth',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'headerInfo'
    ])
  },
  data () {
    return {
      backImg: {
        backgroundImage: 'url(' + backImg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      },
      backImg1: backImg1,
      backImg2: backImg2
    }
  },
  methods: {
    goBack () {
      this.$router.push('homePage')
    },
    toListPage () {
      if (this.RnInfo.token) {
        this.$store.commit('prodClass', 'FP103')
        this.$router.push({ name: 'IntelligentDepositProducts' })
      } else {
        Dialog.alert({
          content: this.$t('label.label9'),
          cancelText: this.$t('btn.btn2'),
          confirmText: this.$t('btn.btn1'),
          onConfirm: () => {
            window.emitRNFunction('goToLogin')
            console.log(this.RnInfo)
          }
        })
      }
    },
    clearStore () {
      this.$store.commit('headerInfo', '')
      this.$store.commit('buyProInfo', '')
      this.$store.commit('prodClass', '')
      this.$store.commit('proInfo', '')
      this.$store.commit('proInfoDetails', '')
    }
  },
  created () {
    this.clearStore()
  }
}
</script>
<style lang="stylus">
  #planForBirth{
    .GridD2371EF7{
      .md-button{
        height .88rem
        line-height .88rem
        .md-button-inner{
          .md-button-content{
            color #ffffff
            height .45rem
            font-size .32rem
            font-weight 500
            line-height .45rem
          }
        }
      }
      .md-button.primary{
        background-color transparent
      }
      .md-button.primary:after{
        border 2px solid #FFFFFF
      }
      .md-button.round{
        border-radius .44rem
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #planForBirth{
    .Grid6DF38708{
      height 100vh
      position relative
      .returnBtn{
        height .45rem
        font-size .32rem
        font-weight 400
        color #FFFFFF
        line-height .45rem
        position absolute
        left 5%
        top 4%
        transform translate(-50%,-50%)
      }
      .GridA80946D5{
        display flex
        flex-direction column
        align-items center
        .text5631D312{
          padding-top 1.2rem
          font-size .56rem
          line-height .66rem
          color #FFFFFF
          font-weight 600
          text-align center
        }
        .text5631D313{
          padding-top .3rem
          font-size .32rem
          font-weight 400
          color #FFFFFF
          line-height .45rem
          text-align center
        }
      }
      .GridF930D8ED{
        padding-top .56rem
        height 1.85rem
        .textImageD034D1AF{
          .img70009100{
            margin 0 auto
            width 1.28rem
            height 1.28rem
            display block
          }
          .text5A37A290{
            padding-top .12rem
            color #FFFFFF
            display flex
            flex-direction column
            justify-content center
            align-items center
            span{
              text-shadow 0 .02rem .04rem rgba(0, 0, 0, 0.2)
              font-weight 400
              font-size .32rem
              line-height .45rem
              text-align center
              word-wrap break-spaces
            }
            .span1{
              position absolute
              width 2.9rem
              top 42%
              left 31%
              transform translate(-50%,-50%)
              font-size .24rem
              line-height .28rem
            }
            .span2{
              position absolute
              font-size .24rem
              line-height .28rem
              width 2rem
              top 54.4%
              right 27.5%
              transform translate(50%,-50%)
            }
          }
        }
      }
      .GridD2371EF7{
        width 100%
        box-sizing border-box
        padding 0 .85rem
        position absolute
        top  90%
        left 50%
        transform translate(-50%,-50%)
      }
    }
    /*.Grid6DF38708::after{
      content ''
      width 2.68rem
      height .1rem
      background-color #FFFFFF
      position absolute
      left 50%
      top 98%
      transform translate(-50%,-50%)
      border-radius .05rem
    }*/
  }
</style>
